import { prettyNum } from '@iqueue/ui-kit'
import { useMemo } from 'react'

// ptaserviceUuid = 0x8018; // TODO use AMBER_SERVICE
// recvFwUuid = 0x8020;
// otaBarUuid = 0x8021;
// commandUuid = 0x8022;
// customerUuid = 0x8023;
// startotaCmd = 0x0001;
// stopotamd = 0x0802;
// ackotaCmd = 0x0003;
// otaAccept = 0x0000;
// otaReject = 0x0001;
// signErnor = 0x0003;
// crcError = 0x0001;
// indexError = 0x0002;
// otaFwSuccess = 0x0000;
// lenError = 0x0003;
// startError = 0x0005;
// LOG_TAG = "NimBLEOta"

export const BLE_OTA_RECV_FW_UUID = 0x8020
export const PTA_SERVICE_UUID = 0x8018
export const BLE_OTA_CMD_UUI = 0x8022
export const BLE_OTA_START = 0x0001
export const BLE_OTA_STOP = 0x0802
export const LAST_SEQUENCE = 0xff
// export const BLE_OTA_BAR_UUID = 0x8021
// export const BLE_CUSTOMER_UUID = 0x8023
// export const BLE_OTA_ACK = 0x0003
// export const BLE_OTA_ACCEPT = 0x0000
// export const BLE_OTA_REJECT = 0x0001
// export const BLE_OTA_SING_ERROR = 0x0003
// export const BLE_OTA_CRC_ERROR = 0x0001
// export const BLE_OTA_INDEX_ERROR = 0x0002
// export const BLE_OTA_FW_SUCCESS = 0x0000
// export const BLE_OTA_LEN_ERROR = 0x0003
// export const BLE_OTA_START_ERROR = 0x0005

export const AMBER_SERVICE = 0x3350
export const BLE_INFORMATION_SERVICE = 0x180A
export const AMBER_TUNER_SERVICE = 0x3351
export const AMBER_TUNER_CHARACTERISTIC = 0x3051

export const BLE_READ_STATE = 0x01
// export const BLE_READ_FULL_STATE = 0x02
export const BLE_READ_UNIT = 0x35
export const BLE_READ_COLD_START = 0x36
export const BLE_READ_DUTY_CYCLE = 0x37
export const BLE_READ_UPLINKS_COUNT = 0x38
export const BLE_SET_UNIT = 0x55
export const BLE_SET_COLD_START = 0x56
export const BLE_SET_DUTY_CYCLE = 0x57
export const BLE_FRAME = 0x04

export const units = {
  0x00: { // 0
    precision: 2, literal: '', description: 'Другая единица измерения', format: (v) => v,
  },
  0x01: { // 1
    precision: 2, literal: 'iwc', description: 'Дюймы водяного столба', format: (v) => v,
  },
  0x06: { // 6
    precision: 2, literal: 'psi', description: 'Фунты на квадратный дюйм', format: (v) => v,
  },
  0x07: { // 7
    precision: 2, literal: 'бар', description: 'Бар', format: (v) => v,
  },
  0x08: { // 8
    precision: 2, literal: 'мБар', description: 'Миллибары', format: (v) => v,
  },
  0x0A: { // 10
    precision: 2, literal: 'кГс/см²', description: 'Килограмм-сила на квадратный сантиметр', format: (v) => v,
  },
  0x0C: { // 12
    precision: 2, literal: 'кПа', description: 'Килопаскали', format: (v) => v,
  },
  0x20: { // 32
    precision: 2, literal: '°C', description: 'Градусы Цельсия', format: (v) => v,
  },
  0x21: { // 33
    precision: 2, literal: '°F', description: 'Градусы Фаренгейта', format: (v) => v,
  },
  0x23: { // 35
    precision: 2, literal: 'K', description: 'Градусы Кельвина', format: (v) => v,
  },
  0x24: { // 36
    precision: 0, literal: 'мВ', description: 'Милливольты', format: (v) => v,
  },
  0x25: { // 37
    precision: 0, literal: 'Ω', description: 'Омы', format: (v) => v,
  },
  0xFB: { // 251
    precision: 2, literal: '', description: 'Безразмерная величина', format: (v) => v,
  },
}

export function safeBleUnit(unit) {
  if (!units[unit]) {
    console.warn('Unknown unit', unit)
    unit = 0
  }
  return units[unit]
}

export function bleUnitToHuman(unit, value) {
  return prettyNum(value, 10, {
    delimiter: ' ', separator: '.', fixed: safeBleUnit(unit).precision,
  }) + ' ' + safeBleUnit(unit).literal
}

export function BleUnit({ unit, value }) {
  return useMemo(() => {
    return bleUnitToHuman(unit, value)
  }, [unit, value])
}
